<template>
    <div
        v-if="loaded"
        class="d-flex align-items-center justify-content-center text-center"
    >
        <div v-if="hasError">
            <h1>Error</h1>
            <p>An error occured while attempting to process your validation confirmation.</p>
            <p>Please try again later, or contact us if this error persists.</p>
        </div>
        <div v-else>
            <h1>Validation Confirmation Successful</h1>
            <p>Thank you, your confirmation has been recieved.</p>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: 'OwnerValidationConfirmation',
    data() {
        return {
            loaded: false,
            hasError: false
        };
    },
    created() {
        if (this.$route.params.ownerId && this.$route.params.confirmationCode) {
            this.processAmlRequest({
                ownerId: this.$route.params.ownerId,
                confirmationCode: this.$route.params.confirmationCode
            })
                .then(() => {
                    this.loaded = true;
                })
                .catch(() => {
                    this.hasError = true;
                    this.loaded = true;
                });
        }
    },
    methods: {
        ...mapActions('properties', ['processAmlRequest'])
    }
};
</script>

<style lang="scss">
.page-owner-validation-confirmation {
    .content {
        max-width: none;
    }
}
</style>
